import request from 'utils/RequestManager';

import config from 'config';

const baseURL = config.GRAPH_HOST;

export function getCompany(clientId) {
    return request({
        method: 'GET',
        baseURL,
        url: `/companies/${clientId}`,
    }).then(res => res.data);
}

export function fetchGraph(id) {
    return request({
        method: 'GET',
        baseURL,
        url: `/trees/${id}`,
    }).then(res => res.data);
}

export function addNodeForButton(buttonId, treeId ,data) {
    return request({
        method: 'POST',
        baseURL,
        url: `/trees/${treeId}/messages/relationships/${buttonId}`,
        data
    }).then(res => res.data);
}

export function editNode(node, treeId) {
    node.buttons.forEach((button, index) => {
        button.index = index;
    });
    return request({
        method: 'PUT',
        baseURL,
        url: `/trees/${treeId}/messages`,
        data: node,
    }).then(res => res.data);
}

export function connectEdgeToDestination(buttonId, destinationId, treeId) {
    return request({
        method: 'PUT',
        baseURL,
        url: `/trees/${treeId}/messages/relationships/${buttonId}/${destinationId}`,
    }).then(res => res.data);
}

export function deleteNode(nodeId, treeId) {
    return request({
        method: 'DELETE',
        baseURL,
        url: `/trees/${treeId}/messages/${nodeId}`,
    }).then(res => res.data);
}

export function removeButtonConnection(buttonId, treeId) {
    return request({
        method: 'DELETE',
        baseURL,
        url: `/trees/${treeId}/messages/relationships/${buttonId}`,
    }).then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/services/api.js